module.exports = __webpack_public_path__ + "8d028042bb1befd46c80e914a0487c57.svg";